var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EContractCostsAreIndexable } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { addYears, startOfDay, subYears, } from "@rentiohq/shared-frontend/dist/utils/date-fns.utils";
import { EAdditionalCostField } from "./AdditionalCost.types";
export var NOW = startOfDay(new Date());
export var MAX_ADDED_YEARS = 60;
export var MAX_SUBTRACTED_YEARS = 60;
export var DATE_MIN = subYears(NOW, MAX_SUBTRACTED_YEARS);
export var DATE_MAX = addYears(NOW, MAX_ADDED_YEARS);
var CURRENT_YEAR = new Date().getFullYear();
export var YEAR_OPTIONS = Array.from({ length: 120 }, function (_, i) { return CURRENT_YEAR - i; });
export var getAdditionalCostsKey = function (index) {
    return "additional-costs-".concat(index);
};
export var getNextAdditionalCostsKey = function (formData) {
    var maxIndex = Object.keys(formData || {}).reduce(function (max, key) {
        var match = key.match(/^additional-costs-(\d+)$/);
        return match ? Math.max(max, parseInt(match[1], 10)) : max;
    }, 0);
    return getAdditionalCostsKey(maxIndex + 1);
};
// Merge the committed form data coming from the parent with the local working
// state, keeping any cost sections that only exist locally (added via the
// button but not saved yet). This prevents an unrelated re-render of the parent
// form from wiping the user's in-progress work.
export var mergePreservingUnsavedCosts = function (previous, incoming) {
    var next = __assign({}, (incoming || {}));
    Object.keys(previous || {}).forEach(function (key) {
        if (!(key in next)) {
            next[key] = previous[key];
        }
    });
    return next;
};
export var getFieldKey = function (_a) {
    var sectionKey = _a.sectionKey, fieldKey = _a.fieldKey;
    return "".concat(sectionKey, "-").concat(fieldKey);
};
export var getValue = function (_a) {
    var _b, _c;
    var sectionKey = _a.sectionKey, fieldKey = _a.fieldKey, formData = _a.formData;
    return (_c = (_b = formData === null || formData === void 0 ? void 0 : formData[sectionKey]) === null || _b === void 0 ? void 0 : _b[fieldKey]) !== null && _c !== void 0 ? _c : "";
};
export var getInitialCost = function (_a) {
    var sectionKey = _a.sectionKey, formData = _a.formData;
    return getValue({
        sectionKey: sectionKey,
        fieldKey: EAdditionalCostField.StartPrice,
        formData: formData,
    });
};
export var getInitialDescription = function (_a) {
    var sectionKey = _a.sectionKey, formData = _a.formData;
    return getValue({
        sectionKey: sectionKey,
        fieldKey: EAdditionalCostField.Description,
        formData: formData,
    });
};
export var indexationToggleValueSetInInitialCosts = function (_a) {
    var sectionKey = _a.sectionKey, formData = _a.formData;
    return getValue({
        sectionKey: sectionKey,
        fieldKey: EAdditionalCostField.IsIndexable,
        formData: formData,
    });
};
export var mapStartToCurrentPriceIfNotIndexable = function (_a) {
    var _b = _a.formData, formData = _b === void 0 ? {} : _b;
    var updatedFormData = {};
    Object.keys(formData).forEach(function (key) {
        var _a;
        var item = formData[key];
        if (item[EAdditionalCostField.IsIndexable] === EContractCostsAreIndexable.Yes) {
            updatedFormData[key] = item;
            return;
        }
        updatedFormData[key] = __assign(__assign({}, item), (_a = {}, _a[EAdditionalCostField.CurrentPrice] = item[EAdditionalCostField.StartPrice]
            ? item[EAdditionalCostField.StartPrice]
            : item[EAdditionalCostField.CurrentPrice], _a));
    });
    return updatedFormData;
};
export var toDate = function (value) {
    if (!value)
        return undefined;
    if (value instanceof Date)
        return value;
    var d = new Date(value);
    return isNaN(d.getTime()) ? undefined : d;
};
